<template>
  <div v-if="show" class="dev-mode-banner" :title="host">
    <span class="dev-mode-banner__main">DEV · LOCAL</span>
    <span class="dev-mode-banner__sub">{{ subline }}</span>
  </div>
</template>

<script>
export default {
  name: 'DevModeBanner',
  computed: {
    show () {
      return process.env.NODE_ENV !== 'production'
    },
    // Der Banner zeigte frueher pauschal "MSAL-Login uebersprungen", sobald es ein
    // Dev-Build war - unabhaengig davon, ob der Bypass wirklich griff. Bei echtem
    // Login war die Aussage schlicht falsch. Jetzt wird derselbe Zustand ausgewertet
    // wie in App.vue/msalConfig.js.
    bypassActive () {
      const host = window.location.hostname
      const isLocalhost = host === 'localhost' || host === '127.0.0.1' || host === '[::1]'
      if (!isLocalhost) return false
      const bypassFlag = typeof config !== 'undefined' ? config.VUE_APP_DEV_MSAL_BYPASS : undefined
      const bypassOff = bypassFlag === false || bypassFlag === 'false'
      const isDevServe = process.env.NODE_ENV !== 'production'
      return (
        sessionStorage.getItem('DEV_MSAL_BYPASS') === '1' ||
        bypassFlag === true || bypassFlag === 'true' ||
        (isDevServe && !bypassOff)
      )
    },
    subline () {
      return this.bypassActive
        ? 'MSAL-Login übersprungen — keine Produktivumgebung'
        : 'Echter MSAL-Login — keine Produktivumgebung'
    },
    host () {
      return window.location.host
    }
  }
}
</script>

<style scoped lang="scss">
.dev-mode-banner {
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100000; // über Drawer (1060) und Formular-Overlays (99999)
  pointer-events: none; // blockiert nie Klicks
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 16px;
  border-radius: 999px;
  background: #b91c1c; // kräftiges Rot
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  font-size: 12px;
  line-height: 1.2;
  text-align: center;

  &__main {
    font-weight: 700;
    letter-spacing: 0.05em;
  }

  &__sub {
    font-size: 10px;
    opacity: 0.9;
  }
}
</style>
